exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/core-js/modules/_object-gops.js
// module id = 222
// module chunks = 1